import { createSvgIcon } from '@mui/material';

const ContainerIcon = createSvgIcon(
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 15C9 11.6863 11.6863 9 15 9H57C60.3137 9 63 11.6863 63 15V57C63 60.3137 60.3137 63 57 63H15C11.6863 63 9 60.3137 9 57V15ZM16.5 13.5C14.8431 13.5 13.5 14.8431 13.5 16.5V55.5C13.5 57.1569 14.8431 58.5 16.5 58.5H31.5C33.1569 58.5 34.5 57.1569 34.5 55.5V16.5C34.5 14.8431 33.1569 13.5 31.5 13.5H16.5ZM40.5 13.5C38.8431 13.5 37.5 14.8431 37.5 16.5V55.5C37.5 57.1569 38.8431 58.5 40.5 58.5H55.5C57.1569 58.5 58.5 57.1569 58.5 55.5V16.5C58.5 14.8431 57.1569 13.5 55.5 13.5H40.5Z"
      fill="currentColor"
    />
    <path
      fill="currentColor"
      d="M16.5 18C16.5 17.1716 17.1716 16.5 18 16.5H30C30.8284 16.5 31.5 17.1716 31.5 18C31.5 18.8284 30.8284 19.5 30 19.5H18C17.1716 19.5 16.5 18.8284 16.5 18Z"
    />
    <path
      fill="currentColor"
      d="M16.5 30C16.5 29.1716 17.1716 28.5 18 28.5H30C30.8284 28.5 31.5 29.1716 31.5 30C31.5 30.8284 30.8284 31.5 30 31.5H18C17.1716 31.5 16.5 30.8284 16.5 30Z"
    />
    <path
      fill="currentColor"
      d="M16.5 36C16.5 35.1716 17.1716 34.5 18 34.5H30C30.8284 34.5 31.5 35.1716 31.5 36C31.5 36.8284 30.8284 37.5 30 37.5H18C17.1716 37.5 16.5 36.8284 16.5 36Z"
    />
    <path
      fill="currentColor"
      d="M16.5 42C16.5 41.1716 17.1716 40.5 18 40.5H30C30.8284 40.5 31.5 41.1716 31.5 42C31.5 42.8284 30.8284 43.5 30 43.5H18C17.1716 43.5 16.5 42.8284 16.5 42Z"
    />
    <path
      fill="currentColor"
      d="M16.5 54C16.5 53.1716 17.1716 52.5 18 52.5H30C30.8284 52.5 31.5 53.1716 31.5 54C31.5 54.8284 30.8284 55.5 30 55.5H18C17.1716 55.5 16.5 54.8284 16.5 54Z"
    />
    <path
      fill="currentColor"
      d="M40.5 18C40.5 17.1716 41.1716 16.5 42 16.5H54C54.8284 16.5 55.5 17.1716 55.5 18C55.5 18.8284 54.8284 19.5 54 19.5H42C41.1716 19.5 40.5 18.8284 40.5 18Z"
    />
    <path
      fill="currentColor"
      d="M40.5 30C40.5 29.1716 41.1716 28.5 42 28.5H54C54.8284 28.5 55.5 29.1716 55.5 30C55.5 30.8284 54.8284 31.5 54 31.5H42C41.1716 31.5 40.5 30.8284 40.5 30Z"
    />
    <path
      fill="currentColor"
      d="M40.5 36C40.5 35.1716 41.1716 34.5 42 34.5H54C54.8284 34.5 55.5 35.1716 55.5 36C55.5 36.8284 54.8284 37.5 54 37.5H42C41.1716 37.5 40.5 36.8284 40.5 36Z"
    />
    <path
      fill="currentColor"
      d="M40.5 42C40.5 41.1716 41.1716 40.5 42 40.5H54C54.8284 40.5 55.5 41.1716 55.5 42C55.5 42.8284 54.8284 43.5 54 43.5H42C41.1716 43.5 40.5 42.8284 40.5 42Z"
    />
    <path
      fill="currentColor"
      d="M40.5 54C40.5 53.1716 41.1716 52.5 42 52.5H54C54.8284 52.5 55.5 53.1716 55.5 54C55.5 54.8284 54.8284 55.5 54 55.5H42C41.1716 55.5 40.5 54.8284 40.5 54Z"
    />
  </svg>,
  'Container',
);

export { ContainerIcon };
